var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text pa-4 outlinedBtn",class:_vm.childclass,attrs:{"elevation":"0","loading":_vm.loading,"color":_vm.color ? _vm.color : 'primary',"to":_vm.to ? _vm.to : '',"x-large":"","outlined":""},on:{"click":_vm.onclick}},[_c('span',{staticClass:"px-2",staticStyle:{"white-space":"normal"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }